"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKey = void 0;
function isKey(fieldSchema, indexName) {
    if (fieldSchema.type === 'Binary' ||
        fieldSchema.type === 'Custom' ||
        fieldSchema.type === 'Date' ||
        fieldSchema.type === 'Number' ||
        fieldSchema.type === 'String') {
        return indexName !== undefined
            ? Boolean(fieldSchema.indexKeyConfigurations &&
                fieldSchema.indexKeyConfigurations[indexName]) : Boolean(fieldSchema.keyType);
    }
    return false;
}
exports.isKey = isKey;
